import { Helmet } from "react-helmet-async";

const SITE = "https://indianalchemy.in";
const DEFAULT_OG = `${SITE}/assets/photos/ia-festive-spread.jpg`;

/**
 * <Seo /> — per-page SEO tags for the SPA.
 * Injects title, meta description, canonical, Open Graph & Twitter tags,
 * and optional page-scoped JSON-LD.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  keywords,
  jsonLd,
}) {
  const url = `${SITE}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Indian Alchemy × Platinum Hospitality" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
